export default class CreatePayrollDetailsRequestDTO {

    private companyId!: number;

    private fileMetaIds!:  Array<number>;

    constructor(companyId: number, fileMetaIds:  Array<number>) {
        this.companyId = companyId;
        this.fileMetaIds = fileMetaIds;
    }

}